module.exports = __webpack_public_path__ + "img/ecological.16d51e95.jpg";